export default "__VITE_ASSET__04cd2127__"